import React from "react";

const NailGelerationProcess = () => {
  return (
    <div className="nailExtensionHeading">
      <h4>The Process of Nail Geleration in Bangalore at SCENT</h4>
      <p>
        Getting a{" "}
        <a href="https://scentlifestyle.com/nail-geleration">
          nail geleration treatment at SCENT
        </a>{" "}
        is a seamless and enjoyable experience. Here’s a step-by-step look at
        what you can expect:
      </p>
      <ul>
        <li>
          <span>1. Consultation:</span>Our technicians will begin with a
          consultation to understand your preferences and any specific
          requirements you may have. This helps us tailor the treatment to suit
          your needs.
        </li>
        <li>
          <span>2. Nail Preparation:</span> Your nails will be cleaned and
          prepped, including trimming, filing, and buffing. This ensures a
          smooth surface for the gel application.
        </li>
        <li>
          <span>3. Gel Application:</span> The chosen gel color will be applied
          in thin layers. Each layer is cured under a UV or LED lamp to harden
          the gel and ensure a durable finish.
        </li>
        <li>
          <span>4. Finishing Touches:</span> Once the gel application is
          complete, a top coat is applied for added shine and protection. Your
          nails will then be gently cleaned and moisturized.
        </li>
        <li>
          <span>5. Aftercare Advice:</span> Our technicians will provide you
          with tips on how to care for your gel nails to extend their life and
          keep them looking great.
        </li>
      </ul>
    </div>
  );
};

export default NailGelerationProcess;
